import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from 'reactstrap';

class IconWithTooltip extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            tooltipOpen: false
        };
    }

    toggleTooltip = () => {
        this.setState({ tooltipOpen: !this.state.tooltipOpen });
    }

    render() {
        if (!this.props.tooltip) return null;

        return (
            <>
                <span className="icon-with-tooltip" id={this.props.id}>
                    <i className={"icon-with-tooltip__icon " + this.props.icon} tabIndex="-1"></i>
                    {!!this.props.label && <span className="icon-with-tooltip__label ml-1">{this.props.label}</span>}
                </span>
                <Tooltip
                    target={this.props.id}
                    isOpen={this.state.tooltipOpen}
                    toggle={this.toggleTooltip}
                    placement={this.props.placement}
                    trigger={this.props.trigger}
                >
                    {this.props.tooltip}
                </Tooltip>
            </>
        );
    }
}

IconWithTooltip.propTypes = {
    id: PropTypes.string.isRequired,
    icon: PropTypes.string,
    label: PropTypes.string,
    tooltip: PropTypes.string,
    placement: PropTypes.string,
    trigger: PropTypes.string
};

IconWithTooltip.defaultProps = {
    //id: () => "icon-with-tooltip-" + Math.floor(Math.random()*1000),
    icon: "fa-light fa-circle-info",
    placement: "right",
    trigger: "hover focus"
};

export default IconWithTooltip;